import { INotificationState } from '../../types/redux/notifications';
import { IRootState } from '../../types/redux/root';

export const notificationsStateSelector = (root: IRootState): INotificationState|undefined => root.notifications;
